<form
  autocomplete="off"
  [formGroup]="form">

  <div class="row">
    <div class="col-12">
      <div class="card mb-3 bg-2">
        <div class="card-body">
          <div class="row mt-2">
            <div class="col-md-12 col-lg-6 col-xxl-4">
              <lib-autocomplete #gerenciadorRegistroRegra [schema]="regraSchema"></lib-autocomplete>
            </div>
            <div *ngIf="!composta" class="col-md-12 col-lg-6 col-xxl-4">
              <lib-autocomplete #gerenciadorRegistroFuncao [schema]="funcaoSchema"></lib-autocomplete>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-sm-6 col-md-4 col-xl-2">
              <lib-datepicker-day #gerenciadorRegistroDataInicio [schema]="dataInicioSchema" ></lib-datepicker-day>
            </div>
            <div class="col-sm-6 col-md-4 col-xl-2">
              <lib-datepicker-day #gerenciadorRegistroDataFim [schema]="dataFimSchema"></lib-datepicker-day>
            </div>
          </div>
        </div>
        <div class="card-footer clearfix">
          <div class="d-flex flex-row justify-content-end">
            <div class="pr-3">
              <button
                mat-raised-button
                color="primary"
                [disabled]="form.invalid || (loading$ | async)"
                label="Pesquisar"
                type="submit"
                (click)="pesquisar(this.form.value); currentPage.next(1);"
                title="Pesquisar"
                aria-label="left"
              >
                <loading-icon [btnLabel]="'Pesquisar'" [loading]="(loading$ | async)"></loading-icon>
              </button>
            </div>
            <div class="">
              <button mat-raised-button
                      [matMenuTriggerFor]="menuExportarRegra"
                      [disabled]="(loadingExport$ | async) || !showExecutar">
                <loading-icon
                  [btnLabel]="'Exportar'"
                  [loading]="loadingExport$ | async"
                ></loading-icon> <span class="caret"></span>
              </button>
              <mat-menu #menuExportarRegra="matMenu">
                <button mat-menu-item (click)="exportarPdf()">
                  <span>PDF</span>
                </button>
                <button mat-menu-item (click)="exportarXls()">
                  <span>Excel</span>
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<app-total-table
  [showRegistersPerPage]="true"
  (onChange)="updatePageSize($event)"
  [totalRegistros]="this.totalRegistros"
></app-total-table>
<table class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
  <thead>
    <tr>
      <th>
        Regra
      </th>
      <th *ngIf="!composta">
        Função
      </th>
      <th>
        Data início vigência
      </th>
      <th>
        Data fim vigência
      </th>
      <th class="text-center">Ações</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of regras">
      <td *ngIf="!regraIsEqual(regraEdicao, r)">{{ r.nome }}</td>
      <td *ngIf="regraIsEqual(regraEdicao, r)">
        <mat-form-field style="width: 100%;">
          <input matInput [(ngModel)]="regraEdicao.nome" [value]="r.nome" />
        </mat-form-field>
      </td>

      <td *ngIf="!composta">{{ r.funcao }}</td>
      <td *ngIf="!regraIsEqual(regraEdicao, r)">{{ r.inicioVigencia | date: 'dd/MM/yyyy' }}</td>
      <td *ngIf="regraIsEqual(regraEdicao, r)">
        <mat-form-field style="width: 90px;">
          <input matInput libMask="00/00/0000" [(ngModel)]="regraEdicao.inicioVigencia"/>
        </mat-form-field>
      </td>

      <td *ngIf="!regraIsEqual(regraEdicao, r)">{{ r.fimVigencia | date: 'dd/MM/yyyy' }}</td>
      <td *ngIf="regraIsEqual(regraEdicao, r)">
        <mat-form-field style="width: 90px;">
          <input matInput libMask="00/00/0000" [(ngModel)]="regraEdicao.fimVigencia"/>
        </mat-form-field>
      </td>

      <td class="d-flex justify-content-center pt-1 pb-1" *ngIf="regraIsEqual(regraEdicao, r)">
        <button mat-icon-button type="button" (click)="save()" title="Salvar">
          <i class="fas fa-save" aria-hidden="true"></i>
        </button>
        <button mat-icon-button type="button" (click)="setModoEdicao(null)" title="Cancelar">
          <i class="fas fa-undo" aria-hidden="true"></i>
        </button>
      </td>

      <td class="d-flex justify-content-center pt-1 pb-1" *ngIf="!regraIsEqual(regraEdicao, r)">
        <button
          mat-icon-button
          type="button"
          (click)="openEditDialog(r, true, composta)"
          title="Consultar"
        >
          <i class="fas fa-search" aria-hidden="true"></i>
        </button>
        <button
          mat-icon-button
          type="button"
          (click)="openEditDialog(r, false, composta)"
          title="Editar completo"
          data-toggle="modal"
          data-target="#confirm-dialog-modal"
        >
          <i class="fas fa-edit" aria-hidden="true"></i>
        </button>
        <button
          mat-icon-button
          color="warn"
          type="button"
          (click)="openDeleteDialog(r)"
          title="Excluir"
          data-toggle="modal"
          data-target="#confirm-dialog-modal"
        >
          <i class="fas fa-trash" aria-hidden="true"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<div class="d-flex justify-content-center mb-5">
  <maps-pagination
    [items]="paginationTotalPage"
    [pageNumber]="currentPage"
    *ngIf="paginationTotalPage && paginationTotalPage > 0"
    (pageSend)="receiverPage($event)"
  ></maps-pagination>
</div>
